<template>
    <ckeditor v-on="$listeners" v-model="computedValue" :editor="editor" :config="config"></ckeditor>
</template>

<script>
export default {
    name: "NullSafeCkEditor",
    props: {
        value: {
            type: String,
            default: '',
        },
        editor: {
            type: Function,
            required: true,
        },
        config: {
            type: Object,
            default: {},
        }
    },
    emits: [
        'update:value',
        'exited'
    ],
    computed: {
        computedValue: {
            get: function() { return this.value ?? ''},
            set: function(newValue) {this.$emit('update:value', newValue)}
        }
    },
}
</script>

<style scoped>

</style>
